/*light gray bg color */
export const defaultStyle = {
  tabbingImageFullContainer: 'tabbingImageFullContainer bg-grayWhite my-[30px] lg:my-[50px] pt-[30px] lg:pt-[50px]',
  tabbingImageContainer:
    'tabs test container max-w-[540px] md:max-w-[720px] lg:max-w-[1364px] mx-auto',
  tabbingImageGroup: 'tabbingImageGroup opened ',
  tabbingImageUL: 'flex flex-wrap transition duration-1000',
  tabbingImageTabContent: 'tab-content px-15 md:px-0',
  tabbingImageListWrapper: 'flex flex-wrap tabbingImageListWrapper',
  tabbingImageListContainer: 'w-full md:w-2/4',
  tabbingImageListContainerFull: 'w-full tabbingImageListContainerFull',
  tabbingImageListContainerInner:
    'transition-transform ease-out overflow-hidden origin-top transform',
  tabbingImageListContainerH1:
    'text-[48px] text-green font-Light mb-[35px] tracking-normal',
  tabbingImageListContainerH2: 'lg:text-xl md:text-xl text-sm font-bold mb-30',
  tabbingImageListContainerP: 'Text-wrap-TAb w-full px-10 md:px-[30px] md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto',
  tabbingImageContentImageContainer: 'w-full md:w-2/4 md:pl-[1rem]',
  tabbingImageContentImage: 'object-cover w-full h-auto',
  tabbingImageList:
    'group/list groupList tab-title w-full md:w-2/4 lg:w-1/4 mb-0 lg:mb-50 md:mb-0 border-black',
  tabbingImageListInner: 'px-20 mb-10 md:mb-50 border-b-1 md:border-none',
  tabbingImageListSection:
    'image relative cursor-pointer md:hover:scale-[1.15] max-w-full w-full imageListSeTbbing tab-advanced',
  tabbingImage: 'mb-30 md:mb-0 w-auto h-full',
  tabbingImageOverlay:
    'overlay static h-auto top-auto left-auto bg-transparent md:absolute md:top-0 md:left-0 md:h-full w-full md:bg-black md:bg-opacity-40',
  tabbingImageOverlaySection:
    'text-[24px] relative bottom-auto left-auto md:absolute md:left-0 md:bottom-30 text- md:text-white w-full md:group-hover/list:bottom-80 duration-500 w-100% box-border',
  tabbingImageOverlayP:
    'tabbingImageOverlayP text-left font-Bold text-[21px] text-white  tracking-[0.53px] box-border cursor-pointer  mb-0  leading-[21px] flex justify-left md:justify-center text-left md:text-center max-md:pr-16 md:px-20',
  tabbingImageArrow:
    'arrow hidden md:block absolute left-0 -bottom-10 text-center duration-500 w-full opacity-0 group-hover/list:bottom-40 group-hover/list:opacity-100',
  tabbingImageSVG: 'rotate-180 inline',
  tabbingImageSVGPath: 'fill-none stroke-white stroke-2',
  tabbingHide: 'overflow-hidden tabbingImageListWrapper close',
  marketingTitle: "capitalize text-left font-Light text-[24px] md:text-[48px] text-green mb-[20px] md:leading-[72px]",
  marketingDesc: "text-[21px] font-Regular tracking-[0.53px] text-black leading-[31.5px]",
  titlePurple: "text-purple md:text-[60px] text-[36px] font-light leading-[43.2px] md:leading-[72px]  font-MDLZBiteType mb-[60px] px-[35px]",
  titleGreen:"textHeadingGreen text-green text-[24px] lg:text-[48px] font-Light leading-[1.2] tracking-normal  mb-[35px] px-0 mt-[-12px] font-light box-border text-left"
};

export const PACKAGING_PLASTICS_TABBING_WRAP = {
  ...defaultStyle,
  tabbingImageFullContainer: 'tabbingImageFullContainer bg-grayWhite py-[30px] lg:py-[50px] px-[20px]  ',
  tabbingImageContainer: "tabbingImageContainer pt-[50px] bg-grayWhite",
  tabbingImageUL: 'flex flex-wrap mt-50  transition duration-1000 pb-[100px]',
  tabbingImageListInner: 'px-30 border-b-1 md:border-none',
}
export const TABBING_WITH_IMAGE_TEXT = {
  ...defaultStyle,
  tabbingImageFullContainer: 'tabbingImageFullContainer bg-grayWhite py-[30px] lg:py-[50px] px-[20px]  ',
  tabbingImageOverlay:
    'overlay static h-auto top-auto left-auto bg-transparent md:absolute md:top-0 md:left-0 md:h-full w-full md:bg-black md:bg-opacity-0',


  tabbingImageListSection:
    ' tab-advanced image relative cursor-pointer md:hover:scale-[1.15] max-w-full w-full imageListSeTbbing ',
  tabbingImageOverlaySection:
    'text-[24px] relative bottom-auto left-auto md:absolute md:left-0 md:bottom-30 text- md:text-white w-full md:group-hover/list:bottom-80 duration-500 w-100% box-border',
  tabbingImageOverlayP:
    'tabbingImageOverlayP text-left font-bold text-[21px] text-white  tracking-[0.53px] box-border cursor-pointer  mb-0  leading-[21px] flex justify-left md:justify-center text-left md:text-center max-md:pr-16',
  tabbingImageFullContainer: 'tabbingImageFullContainer bg-grayWhite py-[30px] lg:py-[50px] px-[20px]  ',
  tabbingImageOverlay:
    'overlay static h-auto top-auto left-auto bg-transparent md:absolute md:top-0 md:left-0 md:h-full w-full md:bg-black md:bg-opacity-40 ',
}

export const THREE_COL_ACCORDION = {
  ...defaultStyle,
  tabbingImageFullContainer: 'tabbingImageFullContainer bg-grayWhite pt-[30px] lg:pt-[50px]',
  tabbingImageUL: 'flex flex-wrap transition duration-1000 justify-center px-[20px] max-w-[900px] mx-auto',
  tabbingImageList: 'group/list groupList tab-title w-full md:w-2/4 lg:w-2/6 mb-0 border-black',
  tabbingImage: 'mb-30 md:mb-0 object-contain w-full h-full p-20',
}

export const IMAGE_WITH_FLAG = {
  ...defaultStyle,
  tabbingImageFullContainer: 'tabbingImageFullContainer bg-grayWhite pt-[50px] pb-[100px]',
  tabbingImageUL: 'flex flex-wrap transition duration-1000',
  tabbingImageList: 'group/list groupList tab-title w-full h-full md:w-2/4 lg:w-1/4 mb-50 md:mb-0 border-black md:items-center',
  tabbingImageOverlay: 'overlay static h-auto top-auto left-auto bg-transparent md:absolute md:top-0 md:left-0 md:h-full w-full md:bg-opacity-40',
  tabbingImageWrapper: 'tabbingImageWrapper w-full',
  tabbingImage: 'tabbingImage mb-30 md:mb-0 object-cover w-full h-full',
  tabbingImageListInner: 'px-20 mb-10 md:mb-50 border-b-1 md:border-none w-full md:h-[300px]',
  tabbingImageListSection: 'tabbingImageListSectionFlag image relative cursor-pointer md:hover:scale-[1.15] max-w-full w-full imageListSeTbbing flex flex-col md:flex-row',
  tabbingImageOverlaySection: 'text-[24px] relative bottom-auto left-auto md:absolute md:left-0 md:bottom-[-120px] md:text-white w-full md:group-hover/list:bottom-[-60px] duration-500 w-100% box-border',
  tabbingImageOverlayP: 'tabbingImageOverlayP text-left font-bold text-[21px] md:group-hover/list:text-[32px] md:group-hover/list:leading-[32px] md:group-hover/list:font-light text-black tracking-[0.53px] box-border cursor-pointer mb-0 leading-[21px] flex justify-start md:justify-center text-center tabbingImageOverlayPArrow',
}

export const TABBING_WITH_BLACK_TEXT = {
  ...defaultStyle,
  tabbingImageListSection:
    'image relative cursor-pointer md:hover:scale-[1.15] max-w-full w-full imageListSeTbbingBlackArrow transition-all duration-500',
  tabbingImageOverlayP: 'tabbingImageOverlayP text-left font-bold text-[21px] md:group-hover/list:text-[32px] md:group-hover/list:leading-[32px] md:group-hover/list:font-light text-black tracking-[0.53px] box-border cursor-pointer mb-0 leading-[21px] flex justify-start md:justify-center text-center tabbingImageOverlayPBlackArrow',
  tabbingImageOverlay:
    'overlay static h-auto top-auto left-auto bg-transparent md:absolute md:top-0 lg:top-45 md:left-0 md:h-full w-full md:bg-black md:bg-opacity-0',
  tabbingImageOverlayP:
    'tabbingImageOverlayP text-left max-md:mb-20 font-Bold text-[21px] text-green md:text-black tracking-[0.53px] box-border cursor-pointer  mb-0  leading-[21px] flex justify-left md:justify-center md:text-center max-md:pr-16',
  tabbingImageOverlaySection:
    'tabbingImageOverlaySection text-[24px] relative bottom-auto left-auto md:absolute md:left-0 md:bottom-[15px] lg:bottom-[70px] text- md:text-white w-full md:group-hover:bottom-80 duration-500 w-100% box-border',
}

export const TABBING_WITH_HOVER_TEXT = {
  ...defaultStyle,
  tabbingImageListSection:
    ' tab-advanced image relative cursor-pointer md:hover:scale-[1.15] max-w-full w-full imageListSeTbbing ',
  tabbingImageOverlaySection:
    'text-[24px] relative bottom-auto left-auto md:absolute md:left-0 md:bottom-30 text- md:text-white w-full md:group-hover/list:bottom-80 duration-500 w-100% box-border',
  tabbingImageOverlayP:
    'tabbingImageOverlayP text-left font-bold text-[21px] text-white  tracking-[0.53px] box-border cursor-pointer  mb-0  leading-[21px] flex justify-left md:justify-center text-left md:text-center max-md:pr-16',
  tabbingImageFullContainer: 'tabbingImageFullContainer bg-grayWhite py-[30px] lg:py-[50px] px-[20px]  ',
  tabbingImageOverlay:
    'overlay static h-auto top-auto left-auto bg-transparent md:absolute md:top-0 md:left-0 md:h-full w-full md:bg-black md:bg-opacity-0 ',

}
export const TABBING_WITH_OPACITY20 = {
  ...defaultStyle,
  tabbingImageListSection:
    ' tab-advanced image relative cursor-pointer md:hover:scale-[1.15] h-[300px] overflow-hidden max-w-full w-full imageListSeTbbing ',
  tabbingImageOverlaySection:
    'text-[24px] relative bottom-auto left-auto md:absolute md:left-0 md:bottom-30 text- md:text-white w-full md:group-hover/list:bottom-80 duration-500 w-100% box-border',
  tabbingImageOverlayP:
    'tabbingImageOverlayP text-left font-bold font-Bold text-[18px] text-white tracking-[0.53px] box-border cursor-pointer mb-0 leading-[1.3] flex justify-left md:justify-center text-left md:text-center max-md:pr-16 md:px-20',
  tabbingImageFullContainer: 'tabbingImageFullContainer bg-grayWhite py-[30px] lg:py-[50px] px-[20px]  ',
  tabbingImageOverlay:
    'overlay static h-auto top-auto left-auto bg-transparent md:absolute md:top-0 md:left-0 md:h-full w-full md:bg-black md:bg-opacity-20 ',

}

export const TABBING_WITH_WHITE_BACKGROUND = {
  ...defaultStyle,
  tabbingImageListSection:
    ' tab-advanced image relative cursor-pointer md:hover:scale-[1.15] max-w-full w-full imageListSeTbbing ',
  tabbingImageOverlaySection:
    'text-[24px] relative bottom-auto left-auto md:absolute md:left-0 md:bottom-30 text- md:text-white w-full md:group-hover/list:bottom-80 duration-500 w-100% box-border',
  tabbingImageOverlayP:
    'tabbingImageOverlayP text-left font-bold text-[21px] text-white  tracking-[0.53px] box-border cursor-pointer  mb-0  leading-[21px] flex justify-left md:justify-center text-left md:text-center max-md:pr-16',
  tabbingImageFullContainer: 'tabbingImageFullContainer whiteBG bg-White py-[30px] lg:py-[50px] px-[20px]  ',
  tabbingImageOverlay:
    'overlay static h-auto top-auto left-auto bg-transparent md:absolute md:top-0 md:left-0 md:h-full w-full md:bg-black md:bg-opacity-0 ',


}

export const TABBING_WITH_IMAGE_LAYOUT = {
  ...defaultStyle,
  tabbingImageListSection:
    ' tab-advanced image relative cursor-pointer md:hover:scale-[1.15] max-w-full w-full imageListSeTbbing ',
  tabbingImageOverlaySection:
    'text-[24px] relative bottom-auto left-auto md:absolute md:left-0 md:bottom-30 text- md:text-white w-full md:group-hover/list:bottom-80 duration-500 w-100% box-border',
  tabbingImageOverlayP:
    'tabbingImageOverlayP text-left font-bold text-[21px] text-white  tracking-[0.53px] box-border cursor-pointer  mb-0  leading-[21px] flex justify-left md:justify-center text-left md:text-center max-md:pr-16',
  tabbingImageFullContainer: 'tabbingImageFullContainer bg-grayWhite py-[30px] lg:py-[50px] px-[20px]  ',
  tabbingImageOverlay:
    'overlay static h-auto top-auto left-auto bg-transparent md:absolute md:top-0 md:left-0 md:h-full w-full md:bg-black md:bg-opacity-40 ',

}

export const MEET_CAREER_TEAM = {
  ...defaultStyle,
  tabbingImageFullContainer: 'tabbingImageFullContainer bg-grayWhite my-[30px] lg:my-[50px] pt-[30px] lg:pt-[50px] career-team-tab',
  tabbingImageOverlayP: 'tabbingImageOverlayP text-left font-Bold text-[18px] text-white  tracking-[0.30px] box-border cursor-pointer  mb-0  leading-[21px] flex justify-left md:justify-center text-left md:text-center max-md:pr-16 md:px-20',
  tabbingImageOverlay: 'overlay static h-auto top-auto left-auto bg-transparent md:absolute md:top-0 md:left-0 md:h-full w-full',
}